import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];

  connect() {
    const stored = this.getCookie("themePreference");
    const theme = stored || this.getSystemPreference();
    this.applyTheme(theme);
  }

  toggle(event) {
    event.preventDefault();
    const current = document.documentElement.getAttribute("data-bs-theme");
    const next = current === "dark" ? "light" : "dark";
    this.applyTheme(next);
    this.setCookie("themePreference", next);
  }

  applyTheme(theme) {
    document.documentElement.setAttribute("data-bs-theme", theme);
    const className = theme === "dark" ? "bi bi-sun" : "bi bi-moon";
    this.iconTargets.forEach((el) => { el.className = className; });
  }

  getSystemPreference() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  }

  getCookie(name) {
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${name}=([^;]*)`),
    );
    return match ? match[1] : null;
  }

  setCookie(name, value) {
    document.cookie = `${name}=${value}; path=/; max-age=31536000`;
  }
}
